/**
 * 分を日本語の所要時間表示にする (`90` → `1時間30分`)。入力は**分**であることを名前で示す
 * (admin の `reports.tsx` には開始・終了から求める同名のローカル関数があり紛らわしいため)。
 *
 * 同じ規則が admin の運転日報 (`breakLabel`) とルート作成画面 (現地待機) の 2 か所に
 * コピーされていたのを 1 本にしたもの (#725 のレビュー指摘)。書式を変えるときに片方だけ
 * 直して表示がずれるのを防ぐ。
 *
 * **数値になっていない入力は `"--"` を返す。** 素朴に計算すると `NaN` → `"NaN時間NaN分"`、
 * `Infinity` → `"Infinity時間NaN分"` が画面に出る。共有の表示関数がこれを吐くと、呼び出しを
 * 増やすたびに同じ事故が起きる。0 分へ丸めて隠すのではなく「出せない」と示す
 * (時刻の `--:--` と同じ扱い)。
 *
 * **負値は符号を付けて出す。** 所要時間として意味を成さない値だが、`0分` に潰すと
 * 退勤 < 出勤 のような入力異常が画面から消えて気づけなくなる。
 * `null` (未記録) の文言は画面ごとに違うので呼び出し側の責務。
 */
export function formatDurationMinutes(minutes: number): string {
  if (!Number.isFinite(minutes)) return "--";
  const rounded = Math.round(minutes);
  const sign = rounded < 0 ? "-" : "";
  const total = Math.abs(rounded);
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${sign}${rest}分`;
  if (rest === 0) return `${sign}${hours}時間`;
  return `${sign}${hours}時間${rest}分`;
}
